$(function(){
	if( $('.thinq-section').length == 0 ) return;
	var $thinq = $('.thinq-section');

	/*
	 * Common Interaction
	 */
	function objInteraction(){
		var $obj = $('.animate-target');
		$obj.each(function() {
			if( !$(this).hasClass('animated') ) {
				var t = $(this).offset().top;
				var b = $(this).offset().top + $(this).outerHeight();
				if(isInScreen(t, b)) {
					var delayTimer = parseInt($(this).attr('data-delay'));
					$(this).delay(delayTimer).queue(function(){$(this).addClass('animated')});
				}
			}
		});
	}

	/*
	 * Visual Interaction
	 */
	function visionVisual(){
		var $visionVisual = $thinq.find('.vision-visual');
		$visionVisual.addClass('animated');

		function visualInteraction(){
			var scrollTop = $(window).scrollTop();
			var result = -(scrollTop * 0.3);

			if ( result <= -300) result = -300;
			$visionVisual.find('.visual .img').css('transform', 'translateY('+result+'px)');
		}
		$(window).on('scroll.visualInteraction', visualInteraction).trigger('scroll.visualInteraction');
	}

	/*
	 * Sticky Menu
	 */
	 function stickyMenu() {
 		var $stickyArea = $thinq.find('.sticky-menu');
 		var $stickyLink = $stickyArea.find('.menu-list');
		var $stickyInner = $stickyArea.find('.sticky-inner');
 		var stickyHeight;
 		var stickyUpperHeight;
 		var activeLineWidth;

 		function stickyResizeSet(){
 			stickyHeight = $stickyArea.height();
 			var naviHeight = $('.navigation').height();
 			var breadcrumbHeight = $('.breadcrumb').height();


 			if(window.innerWidth >= 768) {
 				$('body').removeClass('isMobile');
 				stickyUpperHeight = naviHeight + breadcrumbHeight;
 			} else {
 				$('body').addClass('isMobile');
 				stickyUpperHeight = naviHeight;

 			}
 			// sticky fixed reset
 			if( $(window).scrollTop() >= stickyUpperHeight ){
 				if(!$stickyArea.hasClass('fixed')){
 					$stickyArea.addClass('fixed');
					setTimeout(function(){
	          $stickyInner.find('.arrow').addClass('js-fade');
	        },3000);
 				}
 			} else {
 				if($stickyArea.hasClass('fixed')){
 					$stickyArea.removeClass('fixed');
 				}
 			}
 		}

 		function stickyScrollSet(){
 			var windowTop = $(window).scrollTop();
 			if(windowTop >= stickyUpperHeight){
 				// sticky fixed
 				if(!$stickyArea.hasClass('fixed')){
 					$stickyArea.addClass('fixed');
					setTimeout(function(){
	          $stickyInner.find('.arrow').addClass('js-fade');
	        },3000);
 				}
 			} else {
 				if($stickyArea.hasClass('fixed')){
 					$stickyArea.removeClass('fixed');
 				}
 			}
 		}

		// Product Tab Scroll Design
		function mScrollCheck(){
			if( $('body').hasClass('no-touch') ){
				$stickyInner.find('.menu-list').mCustomScrollbar({
					theme:'dark',
					mouseWheelPixels:300,
					axis:'x'
				});
			} else {
				$stickyInner.append('<div class="arrow"></div>');
				$stickyInner.on('touchend', function(){
					$stickyInner.find('.arrow').addClass('js-fade');
				});
			}
		}

		mScrollCheck();
 		$(window).on('resize.stickyResizeSet', stickyResizeSet).trigger('resize.stickyResizeSet');
 		$(window).on('scroll.stickyScrollSet', stickyScrollSet).trigger('scroll.stickyScrollSet');

 	}

	/*
	 * Description Slide
	 */
	function visionDesc(){
		var $visionDesc = $thinq.find('.vision-description');
		var $descSlide = $visionDesc.find('.description-slide');

		$descSlide.slick({
			dots: true,
			infinite: true,
			arrows: true,
			prevArrow: '<button class="slick-prev slick-arrow" type="button">Previous</button>',
			nextArrow: '<button class="slick-next slick-arrow" type="button">Next</button>',
			rtl: true
		});
	}

	/*
	 * Technology
	 */
	function visionTech(){
		var $visionTech = $thinq.find('.vision-tech');
		//var $videoLayer = $thinq.find('.common-video-layer');
		var $techArea = $visionTech.find('.technology');
		var $techLayer = $visionTech.find('.technology-detail-layer');
		var $techAreaMobile = $visionTech.find('.technology-mobile');
		var $techLayerMobile = $visionTech.find('.technology-detail-layer-mobile');
		var $techSlide = $thinq.find('.technology-slide');
		var $techSlideLayer = $techLayerMobile.find('.technology-detail-slide');
		var techIntervalTimer;

		// Video Layer
		/*
		function videoPlayLayer(){
			$visionTech.find('.btn-play').on('click',function(e){
				e.preventDefault();

				var targetId = $(this).attr('href');

				useScrollSmooth = false;
				$('body').addClass('body-scroll-hidden-fix');

				$videoLayer.show().stop().animate({'opacity':'1'}, 500);
				$videoLayer.find(targetId).show();
				$videoLayer.find(targetId).find('.vjs-big-play-button').trigger('click');

				focusTrap(targetId);
			});

			$videoLayer.find('.btn-close').on('click',function(e){
				e.preventDefault();

				var $targetVideo = $(this).closest('.video-detail');

				useScrollSmooth = true;
				$('body').removeClass('body-scroll-hidden-fix');

				$targetVideo.find('video')[0].pause();
				$targetVideo.hide();
				$videoLayer.stop().animate({'opacity':'0'}, 500, function(){
					$(this).hide();
				});

				$visionTech.find('.btn-play').focus();
			});
		}
		*/

		// Technology Init
		function techInit(){
			if( !$visionTech.hasClass('animated') ) {
				var t = $visionTech.offset().top;
				var b = $visionTech.offset().top + $visionTech.outerHeight();
				if(isInScreen(t, b)) {
					$visionTech.addClass('animated');
					setTimeout(function(){
						$techArea.find('.point-block li').eq(0).find('a').trigger('click');
						$techSlide.addClass('complete');
					}, 500);
				}
			}
		}
		$(window).on('scroll.techInit', techInit).trigger('scroll.techInit');

		// Technology Scene
		function techScene(){
			function scenePlay(e){
				e.preventDefault();

				var $target = $(e.target);
				var idx = $target.closest('li').index();

				$techArea.find('.text-block li').removeClass('active').eq(idx).addClass('active');
				$techArea.find('.point-block li').removeClass('active').eq(idx).addClass('active');
				$techArea.find('.scene-block li').removeClass('active').eq(idx).addClass('active');
				$techArea.find('.scene-block .link-area a').removeClass('active').eq(idx).addClass('active');

				var src = $techArea.find('.line-area .line').eq(idx).find('img').attr('data-src');
				$techArea.find('.line-area .line img').attr('src', '/sa/lg-thinq/resource/images/vision/blank.gif');
				$techArea.find('.line-area .line').eq(idx).find('img').attr('src', src);

				if(techIntervalTimer) clearInterval(techIntervalTimer);
				techInterval(idx);
			}
			$techArea.find('.text-block a').click(scenePlay);
			$techArea.find('.point-block a').click(scenePlay);
		}

		// Technology Scene Interval
		function techInterval(va){
			techIntervalTimer = setInterval(function(){
				va++;
				if(va >= 3) va = 0;

				$techArea.find('.text-block li').removeClass('active').eq(va).addClass('active');
				$techArea.find('.point-block li').removeClass('active').eq(va).addClass('active');
				$techArea.find('.scene-block li').removeClass('active').eq(va).addClass('active');
				$techArea.find('.scene-block .link-area a').removeClass('active').eq(va).addClass('active');

				var src = $techArea.find('.line-area .line').eq(va).find('img').attr('data-src');
				$techArea.find('.line-area .line img').attr('src', '/sa/lg-thinq/resource/images/vision/blank.gif');
				$techArea.find('.line-area .line').eq(va).find('img').attr('src', src);
			}, 6000);
		}

		// Technology Detail Layer
		function visionLayer(){
			$techArea.find('.btn-layer').on('click',function(e){
				e.preventDefault();

				var idx = $(this).index();
				clearInterval(techIntervalTimer);

				$visionTech.find('.title-area').stop().animate({'opacity':'0'}, 500);
				$visionTech.find('.technology').stop().animate({'opacity':'0'}, 500);

				$techLayer.addClass('active');
				$techLayer.find('.visual li').removeClass('active').eq(idx).addClass('active');

				$techLayer.stop().animate({'right':'0'}, 500, function(){
					$techLayer.find('.list li').removeClass('active').eq(idx).addClass('active');
					$techLayer.find('.description li').removeClass('active').eq(idx).addClass('active');
					$techLayer.find('.list').addClass('animated');

					$techLayer.find('.list li a').attr('aria-selected', 'false');
					$techLayer.find('.list li').eq(idx).find('a').attr('aria-selected', 'true');

					focusTrap('.technology-detail-layer');
				});
			});

			$techLayer.find('.btn-close').on('click',function(e){
				e.preventDefault();

				$visionTech.find('.title-area').css({'opacity':'1'});
				$visionTech.find('.technology').css({'opacity':'1'});
				$techLayer.find('.list li a').attr('aria-selected', 'false');

				$techLayer.stop().animate({'right':'-100%'}, 500, function(){
					$techLayer.find('.visual li').removeClass('active');
					$techLayer.find('.list li').removeClass('active');
					$techLayer.find('.description li').removeClass('active');
					$techLayer.find('.list').removeClass('animated');
					$techLayer.removeClass('active');
					$techArea.find('.point-block li').eq(0).find('a').trigger('click');
					$techArea.find('.point-block li').eq(0).find('a').focus();
				});
			});

			$techLayer.find('.list a').on('click',function(e){
				e.preventDefault();

				var $self = $(this);
				var $target = $self.parent('li');
				var idx = $target.index();

				$techLayer.find('.list li').removeClass('active').find('a').attr('aria-selected', 'false');
				$self.attr('aria-selected', 'true');
				$target.addClass('active');
				$techLayer.find('.description li').removeClass('active').eq(idx).addClass('active');
				$techLayer.find('.visual li').removeClass('active').eq(idx).addClass('active');
			});
		}

		// Technology Slide
		function visionSlide(){
			$techSlide.slick({
				dots: true,
				infinite: true,
				arrows: true,
				prevArrow: '<button class="slick-prev slick-arrow" type="button">Previous</button>',
				nextArrow: '<button class="slick-next slick-arrow" type="button">Next</button>',
				rtl: true
			});
			$techSlideLayer.slick({
				dots: true,
				infinite: false,
				arrows: false,
				prevArrow: '<button class="slick-prev slick-arrow" type="button">Previous</button>',
				nextArrow: '<button class="slick-next slick-arrow" type="button">Next</button>',
				rtl: true
			});
			$techSlideLayer.on('beforeChange', function(event, slick, currentSlide, nextSlide){
				$techLayerMobile.find('.visual li').removeClass('active').eq(nextSlide).addClass('active');
				$techLayerMobile.find('.list li').removeClass('active').eq(nextSlide).addClass('active');

				$techLayerMobile.find('.list li button').attr('aria-selected', 'false');
				$techLayerMobile.find('.list li').eq(nextSlide).find('button').attr('aria-selected', 'true');
			});
		}

		// Technology Detail Mobile Layer
		function visionLayerMobile(){
			$techAreaMobile.find('.btn-more').on('click',function(e){
				e.preventDefault();

				var idx = $(this).attr('data-index');

				useScrollSmooth = false;
				$('body').addClass('body-scroll-hidden-fix');

				$techLayerMobile.find('.visual li').removeClass('active').eq(idx).addClass('active');
				$techLayerMobile.show().stop().animate({'opacity':'1'}, 500);
				$techLayerMobile.find('.list li').removeClass('active').eq(idx).addClass('active');

				if($techSlideLayer.hasClass('slick-initialized')){
					$techSlideLayer.slick('setPosition');
					$techSlideLayer.slick('slickGoTo', idx);

					setTimeout(function(){
						$techSlideLayer.addClass('delay-opacity');
					}, 500);
				}

				$techLayerMobile.find('.btn-close').focus();
				focusTrapSet('.technology-detail-layer-mobile');
			});

			$techLayerMobile.find('.btn-close').on('click',function(e){
				e.preventDefault();

				useScrollSmooth = true;
				$('body').removeClass('body-scroll-hidden-fix');
				$techLayerMobile.find('.list li button').attr('aria-selected', 'false');

				$techLayerMobile.stop().animate({'opacity':'0'}, 500, function(){
					$(this).hide();
					$techSlideLayer.removeClass('delay-opacity');
					$techAreaMobile.find('.slick-current .btn-more').focus();
				});
			});

			$techLayerMobile.find('.list button').on('click',function(e){
				e.preventDefault();

				var $self = $(this);
				var $target = $self.parent('li');
				var idx = $target.index();

				$techLayerMobile.find('.list li').removeClass('active').find('button').attr('aria-selected', 'false');
				$self.attr('aria-selected', 'true');
				$target.addClass('active');
				$techSlideLayer.slick('slickGoTo', idx);
			});
		}

		// Resize Reset
		var resizeInterval = false;
		function setResize(){
			if(resizeInterval) clearTimeout(resizeInterval);
			resizeInterval = setTimeout(function() {
				if( window.innerWidth < 768 ){
					$techLayer.find('.btn-close').trigger('click');
					clearInterval(techIntervalTimer);
				} else {
					$techLayerMobile.find('.btn-close').trigger('click');
					if(!techIntervalTimer){
						$techArea.find('.point-block li').eq(0).find('a').trigger('click');
					}
				}
			}, 100);
		}
		$(window).on('resize.setResize', setResize).trigger('resize.setResize');

		//videoPlayLayer();
		visionSlide();
		stickyMenu();
		techScene();
		visionLayer();
		visionLayerMobile();
	}

	visionVisual();
	visionDesc();
	visionTech();
	$(window).on('scroll.objInteraction', objInteraction).trigger('scroll.objInteraction');
});
